module.exports = __webpack_public_path__ + "static/dd-logo-2fbfdd6aeb5e9bc35c395fdc599f9df8.ico";